import React from 'react';
import { useIntl } from 'react-intl';
import { Divider, Stack, Typography, IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { formatListItemDate } from '../../../../Helpers/dates';
import { CenteredFlexBox } from '../../../../Components/FlexBox';

const UserImapsListItems = function UserImapsListItems({
  userImaps,
  onClick,
  searchedValue,
}) {
  const intl = useIntl();

  const openEditDialogHandler = (userImap) => {
    onClick(userImap);
  };

  const filteredUserImaps =
    userImaps?.filter(
      (userImap) =>
        !searchedValue ||
        userImap.branchDescription
          ?.toLowerCase()
          ?.includes(searchedValue?.toLowerCase())
    ) ?? [];

  return (
    <div>
      <CenteredFlexBox
        sx={{
          backgroundColor: 'background.paper',
          padding: '16px',
          position: 'sticky',
          top: 0,
          zIndex: 1,
        }}
      >
        <Typography variant="h6" sx={{ width: '18%' }}>
          {intl.messages.BRANCH}
        </Typography>
        <Typography variant="h6" sx={{ width: '26%' }}>
          {intl.messages.IMAP_USERNAME}
        </Typography>
        <Typography variant="h6" sx={{ width: '14%' }}>
          {intl.messages.FREQUENCY}
        </Typography>
        <Typography variant="h6" sx={{ width: '18%' }}>
          {intl.messages.LASTSCANNED}
        </Typography>
        <Typography variant="h6" sx={{ width: '24%' }}>
          {intl.messages.LASTFULLSCAN}
        </Typography>
      </CenteredFlexBox>
      <Stack divider={<Divider />}>
        {filteredUserImaps?.map((userImap, index) => (
          <CenteredFlexBox key={`${String(index)}`} padding="16px" gap="30px">
            <Typography variant="body2" sx={{ width: '18%' }}>
              {userImap.branchDescription}
            </Typography>
            <Typography variant="body2" sx={{ width: '28%' }}>
              {userImap.imapUserName}
            </Typography>
            <Typography variant="body2" sx={{ width: '14%' }}>
              {userImap.frequency} min
            </Typography>
            <Typography
              variant="body2"
              sx={{ width: '20%' }}
              color={
                new Date(userImap.lastScanned).getTime() +
                  userImap.frequency * 60 * 1000 >=
                Date.now()
                  ? 'textPrimary'
                  : 'error'
              }
            >
              {formatListItemDate(userImap.lastScanned, true)}
            </Typography>
            <Typography variant="body2" sx={{ width: '20%' }}>
              {formatListItemDate(userImap.lastFullScan, true)}
            </Typography>
            <Tooltip title={intl.messages.EDIT_USERIMAP} placement="top">
              <IconButton
                key={userImaps.branchId}
                onClick={() => openEditDialogHandler(userImap)}
              >
                <EditIcon />
              </IconButton>
            </Tooltip>
          </CenteredFlexBox>
        ))}
      </Stack>
    </div>
  );
};

export default UserImapsListItems;
